import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberSubmarine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M16.28 28.415a1 1 0 0 1 .38-.075h37.32c5.192 0 9.4 4.208 9.4 9.4s-4.208 9.4-9.4 9.4H16.66a1 1 0 0 1-.38-.075l-14.73-6.05a1 1 0 0 1-.62-.925v-4.7a1 1 0 0 1 .62-.925zm.577 1.925L2.93 36.06v3.36l13.927 5.72H53.98c4.088 0 7.4-3.312 7.4-7.4s-3.312-7.4-7.4-7.4z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M1.93 29.97a1 1 0 0 1 1 1V44.5a1 1 0 1 1-2 0V30.97a1 1 0 0 1 1-1M4.86 27.86a1 1 0 0 1 1-1h2.41a1 1 0 0 1 .883.53l2.14 4.02a1 1 0 0 1-1.766.94L7.67 28.86H6.86v4.84a1 1 0 1 1-2 0zM5.86 41.14a1 1 0 0 1 1 1v4.85h.81l1.857-3.49a1 1 0 0 1 1.766.94l-2.14 4.02a1 1 0 0 1-.883.53H5.86a1 1 0 0 1-1-1v-5.85a1 1 0 0 1 1-1M28.535 21.31A7.35 7.35 0 0 1 34.68 18h6.31a2.71 2.71 0 0 1 2.71 2.71v8.62a1 1 0 1 1-2 0v-8.62a.71.71 0 0 0-.71-.71h-6.31a5.35 5.35 0 0 0-4.475 2.41l-4.93 7.47a1 1 0 1 1-1.67-1.1zM26.12 36.53a1.48 1.48 0 1 0 0 2.96 1.48 1.48 0 0 0 0-2.96m-3.48 1.48a3.48 3.48 0 1 1 6.96 0 3.48 3.48 0 0 1-6.96 0M36.81 36.53a1.48 1.48 0 1 0 0 2.96 1.48 1.48 0 0 0 0-2.96m-3.48 1.48a3.48 3.48 0 1 1 6.96 0 3.48 3.48 0 0 1-6.96 0M47.49 36.53a1.48 1.48 0 1 0 0 2.96 1.48 1.48 0 0 0 0-2.96m-3.48 1.48a3.48 3.48 0 1 1 6.96 0 3.48 3.48 0 0 1-6.96 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M37.82 23.86a1 1 0 0 1 1-1h3.05a1 1 0 1 1 0 2h-3.05a1 1 0 0 1-1-1M41.18 12.23a.53.53 0 0 0-.53.53V19a1 1 0 1 1-2 0v-6.24a2.53 2.53 0 0 1 2.53-2.53 1 1 0 1 1 0 2M34.68 15.41a1 1 0 0 1 1 1V19a1 1 0 1 1-2 0v-2.59a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberSubmarine;
